/* eslint-disable compat/compat, @typescript-eslint/no-unsafe-call, @typescript-eslint/unbound-method */
import {
  takeLatest, all, call, put,
} from 'redux-saga/effects';
import { formActions, FormActionTypes } from './formActions';
import { visibilityActions } from '../visibility/visibilityActions';
import { apiService } from '../../services/apiService';
import * as formSubmit from '../../models/formSubmit';

export interface ResponseGenerator{
  config?:any,
  data?:any,
  headers?:any,
  request?:any,
  status?:number,
  statusText?:string,
  insertStatus?: string,
}

export function* userFetch(action: ReturnType<typeof formActions.submited>) {
  try {
    yield put(formActions.loading());
    const response: ResponseGenerator = yield call(
      apiService.submitForm,
      action.payload,
    );
    yield put(formActions.loaded());
    if (response.status === 200) {
      yield put(formActions.success());
    }
  } catch (error: any) {
    const errorStatusCode = error.response.status === 400;
    const checkValidRemId = error.response.data.insertStatus === 'N';
    yield put(formActions.loaded());
    if (errorStatusCode && checkValidRemId) {
      yield put(formActions.inValidRemId());
      yield put(visibilityActions.bladeChangeFocus('yourDetails'));
      yield put(visibilityActions.bladeChangeDisplay('yourDetails'));
    } else {
      yield put(formActions.failure());
    }
  }
}

function* workGetUsersFetch() {
  yield takeLatest(formActions.submited, userFetch);
}

export default function* formSubmitSaga() {
  yield all([workGetUsersFetch()]);
}
